<template>
  <layout-public>
    <section class="banner-text padding-bottom why-improve">
      <div class="signup-banner">
        <h1>Start your free trial</h1>
        <p>Get full access for  5 users for 14 days</p>
        <span>No credit card required!</span>
      </div>
      <v-row no-gutters>
        <v-col class="banner-wrapper mt-5">
          <!-- Shape Background -->
          <!-- <v-row align-center justify-center class="mt-5 h-d-w">
            <v-col cols="12" md="12" class="text-center">
              <h1 class="font-sora mt-5">How Does it Work?</h1>
              <p class="fs-22">
                Start your free trail and get full access for  5 users for 14 days!
              </p>
            </v-col>
          </v-row> -->

          <v-container class="banner-img-text-wrapper" style="text-align: left">
            <!-- Banner Left Wrapper -->
            <v-row class="flex-wrap-reverse">

              <!-- Steps -->
              <v-col cols="12" lg="6" class="d-flex justify-lg-end justify-center">
                <div class="steps-container">
                  <div class="h-d-w-show text-center">
                    <h1 class="font-sora mt-5">How Does it Work?</h1>
                    <p class="fs-22 mb-5">
                      During your free trial one of our team will reach out to see how
                      it’s going.
                    </p>
                  </div>
                  <div class="step">
                    <img src="/static/free-trial/step-1.png" class="step-image" alt="Step 1" />
                    <div class="step-content">
                      <h3>Complete the Form</h3>
                      <!-- <p>Fill out your details using the form.</p> -->
                    </div>
                  </div>

                  <div class="step">
                    <img src="/static/free-trial/step-2.png" class="step-image" alt="Step 2" />
                    <div class="step-content">
                      <h3>Gain Instant Access</h3>
                      <!-- <p>
                        You will gain <strong>instant access</strong> to the
                        IMPROVE platform and all of the course content and the
                        learning management system.
                      </p> -->
                    </div>
                  </div>

                  <div class="step">
                    <img src="/static/free-trial/improve-online-contact-the-team.png" class="step-image" alt="Step 2" />
                    <div class="step-content">
                      <h3>One of our team will be in touch to see how you are getting on​</h3>
                      <!-- <p>
                        You will gain <strong>instant access</strong> to the
                        IMPROVE platform and all of the course content and the
                        learning management system.
                      </p> -->
                    </div>
                  </div>

                  <div class="step last">
                    <img src="/static/free-trial/improve-online-book-a-demo.png" class="step-image" alt="Step 2" />
                    <div class="step-content">
                      <h3>Ready to go live? Need help? Fancy a demo? Drop us an email hello@improve.online​</h3>
                      <!-- <p>
                        You will gain <strong>instant access</strong> to the
                        IMPROVE platform and all of the course content and the
                        learning management system.
                      </p> -->
                    </div>
                  </div>

                  <!-- <div class="step">
                    <img src="/static/free-trial/step-3.png" class="step-image" alt="Step 3" />
                    <div class="step-content">
                      <h3>14 Day FREE Trial</h3>
                      <p>
                        The trial has <strong>up to 5 users</strong> and will stay
                        live for <strong>2 weeks</strong>.
                      </p>
                    </div>
                  </div> -->

                  <!-- <div class="step">
                    <img src="/static/free-trial/step-4.png" class="step-image" alt="Step 4" />
                    <div class="step-content">
                      <h3>Arrange a Demo</h3>
                      <p>
                        Free trial customers can book a demo directly from the
                        platform by clicking the header button. Or email
                        <a href="mailto:hello@improve.online" style="text-decoration: underline;"
                          ><strong>hello@improve.online</strong></a
                        >. We're also here to offer help and support.
                      </p>
                    </div>
                  </div> -->

                  <!-- <div class="step">
                    <img src="/static/free-trial/step-5.png" class="step-image" alt="Step 5" />
                    <div class="step-content">
                      <h3>12 Month Subscription</h3>
                      <p>
                        Sign up for a 12-month subscription by dropping us an
                        email at
                        <a href="mailto:hello@improve.online" style="text-decoration: underline;"
                          ><strong>hello@improve.online</strong></a
                        >
                        or giving us a call on <strong>0115 6786278</strong>.
                      </p>
                    </div>
                  </div> -->

                  <!-- <div class="step">
                    <img src="/static/free-trial/step-6.png" class="step-image" alt="Step 6" />
                    <div class="step-content">
                      <h3>Forgotten Your Password?</h3>
                      <p>
                        If you forget your password simply hit the             
                        <strong>forgot password button</strong> and enter the
                        email address you signed up with.
                      </p>
                    </div>
                  </div>  -->
                                  <!-- FORGOT PASSWORD-->
                    <v-card-text class="center-v forgot_password">
                    <router-link class="" to="/forgot-password"
                      >Forgotten your password? Click here</router-link
                    >
                  </v-card-text>
                </div>
              </v-col>

              <!-- Microlearning Image -->
              <v-col cols="12" lg="6" class="d-flex justify-lg-end justify-center">
                <free-trial-form />
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </section>
  </layout-public>
</template>

<script>
import LayoutPublic from '@/layouts/Signup';
import FreeTrialForm from '../../components/FreeTrialForm.vue';

export default {
  name: 'Login',
  metaInfo() {
    return {
      title: 'IMPROVE: The Complete Microlearning Platform for SMEs',
      meta: [
        {
          name: 'description',
          content:
            'Train, develop & retain your people with IMPROVE - an ultimate online learning platform designed for SMEs. Prices start from just 66p per person per month.',
        },
        {
          property: 'og:title',
          content: 'IMPROVE: The Complete Microlearning Platform for SMEs',
        },
        {
          property: 'og:description',
          content:
            'Train, develop & retain your people with IMPROVE - an ultimate online learning platform designed for SMEs. Prices start from just 66p per person per month.',
        },
        {
          property: 'og:image',
          content: 'https://www.improve.online/static/homepage/Compliance.png',
        },
      ],
    };
  },
  components: {
    LayoutPublic,
    FreeTrialForm,
  },
};
</script>

<style>
.signup-banner {
  background-image: url(/static/pricing/improve-free-trial-banner.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 256px;
  width: 100%;
  margin-top: -30px;
}

.signup-banner h1 {
  font-size: 50px;
  font-weight: 700;
  color: #122034;
  margin-bottom: 20px;
  max-width: 1420px;
  text-align: center;
}

.signup-banner p {
  font-size: 17px;
  font-weight: 400;
  color: #122034;
  max-width: 918px;
  text-align: center;
}

.signup-banner span {
  font-size: 17px;
  font-weight: 700;
  color: #122034;
  max-width: 918px;
  text-align: center;
  margin-top: 5px;
}

.steps-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 50px;
}

.step {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  position: relative;
}

.step-image {
  width: 120px;
  height: auto;
  margin-right: 20px;
  z-index: 1;
}

.step-icon {
  width: 50px;
  height: 50px;
  background-color: #d4edda;
  color: #155724;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  margin-right: 20px;
  border: 2px solid #c3e6cb;
  text-align: center;
}

.step-content h3 {
  margin: 0 0 5px;
  font-size: 15px !important;
  font-weight: 700;
  color: #122034;
}

.step-content p {
  margin: 0;
  font-weight: 400;
  font-size: 14px !important;
  color: #000000;
  max-width: 462px;
}

.last.step::before {
  display: none;
}

.step::before {
  content: '';
    position: absolute;
    left: 27px;
    top: 46px;
    transform: translateX(-50%);
    width: 2px;
    height: 100%;
    background: repeating-linear-gradient(to bottom, #67BD95 0, #67BD95 4px, /* Dot size */ transparent 4px, transparent 10px /* Gap size */);
    z-index: 0;
}

.step:last-child::before {
  display: none;
}

.h-d-w-show {
  display: none;
}

.h-d-w {
  display: block;
}

@media (max-width: 1264px) {
  .h-d-w {
    display: none;
  }

  .h-d-w-show {
    display: block;
  }
}

@media screen and (max-width: 600px) {
  .step {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .step::before {
    display: none;
  }
}
</style>
